"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("../shared");
function createBrowserConfig(_a) {
    var settingsKey = _a.settingsKey;
    var container = window._cianConfig;
    if (!container) {
        throw new Error("_cianConfig - not found in window");
    }
    var settings = container[settingsKey];
    if (!settings) {
        throw new Error("Missing settings in _cianConfig." + settingsKey);
    }
    if (!Array.isArray(settings)) {
        var msg = "Expecting array of settings in _cianConfig." + settingsKey + ". Got " + JSON.stringify(settings, null, 2);
        throw new Error(msg);
    }
    settings.forEach(function (setting) {
        if (!shared_1.validate(setting)) {
            throw new Error("Received unexpected entry in _cianConfig." + settingsKey + ": " + JSON.stringify(setting, null, 2));
        }
    });
    var source = new shared_1.Source(settings);
    return new shared_1.Config(source);
}
exports.createBrowserConfig = createBrowserConfig;
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@cian/config/browser/interface.js
// module id = 237
// module chunks = 0